import React from 'react';
import PropTypes from 'prop-types';

import './Team.css';

function Team({ daten, divHeight, viewportWidth }) {
  return (
    <div
      className={viewportWidth > 768 ? 'team' : 'team-mobil'}
      style={viewportWidth > 768 ? { height: divHeight } : null}
    >
      <div
        className={viewportWidth > 768 ? 'team_left' : 'team_left-mobil'}
        id="team_left_id"
      >
        <h3>Team</h3>
        <p>{daten[0].team}</p>
      </div>

      <div className={viewportWidth > 768 ? 'team_right' : 'team_right-mobil'}>
        <h3>Betreuung</h3>
        <p>{daten[0].betreuer}</p>
      </div>
    </div>
  );
}

export default Team;

Team.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  daten: PropTypes.object.isRequired,
  divHeight: PropTypes.number.isRequired,
  viewportWidth: PropTypes.number.isRequired,
};
